module.exports = __webpack_public_path__ + "img/icon-gen-shortlink.64183648.png";